module.exports = __webpack_public_path__ + "static/img/iconshipinlan_shengyin_16_bai.c90dbf7d.png";